export default "__VITE_ASSET__C3xkBk1k__"